(function () {

  if (window.GanaTuBiciTermsInitialized) {
    return;
  }

  window.GanaTuBiciTermsInitialized = true;

  const GTB_CAMPAIGN = 'Oiz 2027';
  const GTB_TERMS_VERSION = 'OIZ-2027-V1';

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'button[id*="checkout" i]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]'
  ].join(',');

  let saveInProgress = false;
  let acceptanceSaved = false;


  function shopifyRoot() {

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }


  function getTermsBoxes() {

    return Array.from(
      document.querySelectorAll('[data-gtb-terms-box]')
    );

  }


  function getCheckboxes() {

    return Array.from(
      document.querySelectorAll('[data-gtb-terms-checkbox]')
    );

  }


  function getCheckoutButtons() {

    return Array.from(
      document.querySelectorAll(CHECKOUT_SELECTOR)
    );

  }


  function termsRequired() {

    return getTermsBoxes().length > 0;

  }


  function termsAreAccepted() {

    const checkboxes = getCheckboxes();

    if (!checkboxes.length) {
      return false;
    }

    return (
      acceptanceSaved === true &&
      checkboxes.every(function (checkbox) {
        return checkbox.checked === true;
      })
    );

  }


  function showMessage(message) {

    document
      .querySelectorAll('[data-gtb-terms-message]')
      .forEach(function (element) {

        if (!message) {
          element.textContent = '';
          element.hidden = true;
          return;
        }

        element.textContent = message;
        element.hidden = false;

      });

  }


  function synchronizeCheckboxes(checked) {

    getCheckboxes().forEach(function (checkbox) {
      checkbox.checked = checked;
    });

  }


  function updateCheckoutButtons() {

    if (!termsRequired()) {
      return;
    }

    const canCheckout =
      termsAreAccepted() &&
      !saveInProgress;

    getCheckoutButtons().forEach(function (button) {

      if (canCheckout) {

        button.disabled = false;

        button.removeAttribute('aria-disabled');

        button.classList.remove(
          'gtb-checkout-disabled'
        );

      } else {

        button.disabled = true;

        button.setAttribute(
          'aria-disabled',
          'true'
        );

        button.classList.add(
          'gtb-checkout-disabled'
        );

      }

    });

  }


  async function saveAcceptanceToShopify() {

    if (saveInProgress) {
      return;
    }

    saveInProgress = true;
    acceptanceSaved = false;

    synchronizeCheckboxes(true);

    updateCheckoutButtons();

    showMessage(
      'Guardando tu aceptación...'
    );

    const acceptedAt =
      new Date().toISOString();

    const attributes = {

      'GanaTuBici Terms Accepted':
        'Yes',

      'GanaTuBici Campaign':
        GTB_CAMPAIGN,

      'GanaTuBici Terms Version':
        GTB_TERMS_VERSION,

      'GanaTuBici Accepted At':
        acceptedAt

    };

    try {

      const response = await fetch(
        shopifyRoot() + 'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({
            attributes: attributes
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Shopify cart update failed.'
        );
      }

      await response.json();

      acceptanceSaved = true;

      synchronizeCheckboxes(true);

      showMessage('');

    } catch (error) {

      console.error(
        'GanaTuBici terms error:',
        error
      );

      acceptanceSaved = false;

      synchronizeCheckboxes(false);

      showMessage(
        'No pudimos guardar tu aceptación. Por favor, inténtalo nuevamente.'
      );

    } finally {

      saveInProgress = false;

      updateCheckoutButtons();

    }

  }


  async function removeAcceptanceFromShopify() {

    if (saveInProgress) {
      return;
    }

    saveInProgress = true;
    acceptanceSaved = false;

    synchronizeCheckboxes(false);

    updateCheckoutButtons();

    try {

      const response = await fetch(
        shopifyRoot() + 'cart/update.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            attributes: {

              'GanaTuBici Terms Accepted':
                'No',

              'GanaTuBici Campaign':
                '',

              'GanaTuBici Terms Version':
                '',

              'GanaTuBici Accepted At':
                ''

            }

          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Shopify cart reset failed.'
        );
      }

      await response.json();

    } catch (error) {

      console.error(
        'GanaTuBici terms reset error:',
        error
      );

    } finally {

      saveInProgress = false;

      updateCheckoutButtons();

    }

  }


  document.addEventListener(
    'change',
    function (event) {

      const checkbox =
        event.target.closest(
          '[data-gtb-terms-checkbox]'
        );

      if (!checkbox) {
        return;
      }

      if (checkbox.checked) {

        saveAcceptanceToShopify();

      } else {

        removeAcceptanceFromShopify();

      }

    }
  );


  document.addEventListener(
    'click',
    function (event) {

      const checkoutButton =
        event.target.closest(
          CHECKOUT_SELECTOR
        );

      if (!checkoutButton) {
        return;
      }

      if (!termsRequired()) {
        return;
      }

      if (
        saveInProgress ||
        !termsAreAccepted()
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();

        showMessage(
          'Debes aceptar las Reglas Oficiales y los Términos y Condiciones antes de continuar.'
        );

        return false;
      }

    },
    true
  );


  document.addEventListener(
    'submit',
    function (event) {

      if (!termsRequired()) {
        return;
      }

      const submitter =
        event.submitter;

      if (
        submitter &&
        submitter.matches(CHECKOUT_SELECTOR) &&
        (
          saveInProgress ||
          !termsAreAccepted()
        )
      ) {

        event.preventDefault();

        event.stopPropagation();

        showMessage(
          'Debes aceptar las Reglas Oficiales y los Términos y Condiciones antes de continuar.'
        );

      }

    },
    true
  );


  const observer =
    new MutationObserver(
      function () {

        if (acceptanceSaved) {
          synchronizeCheckboxes(true);
        }

        updateCheckoutButtons();

      }
    );


  function initializeGanaTuBiciTerms() {

    acceptanceSaved = false;

    synchronizeCheckboxes(false);

    updateCheckoutButtons();

    if (document.body) {

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeGanaTuBiciTerms
    );

  } else {

    initializeGanaTuBiciTerms();

  }

})();